import { gql } from '@apollo/client';
import React from 'react';
import { externalEditText } from '../../../utils/post/externalPost';
import { editIcon } from '../editorIcons';
import ToolbarButton, { ToolbarButtonGroup } from './buttons/ToolbarButton';
import styles from './ImportedToolbar.module.scss';
import type { ImportedToolbar_ExternalPostFragment } from '../../../graphql/generated/graphqlTypes';

const EXTERNAL_POST_FRAGMENT = gql`
  fragment ImportedToolbar_externalPost on ExternalPost {
    editUrl
    platform
  }
`;

interface ImportedToolbarProps {
  externalPost: ImportedToolbar_ExternalPostFragment;
}

const ImportedToolbar = ({
  externalPost: { editUrl, platform },
}: ImportedToolbarProps) => (
  <a
    href={editUrl}
    className={styles.link}
    rel="noopener noreferrer"
    target="_blank"
  >
    <ToolbarButtonGroup>
      <ToolbarButton icon={editIcon}>
        {externalEditText(platform)}
      </ToolbarButton>
    </ToolbarButtonGroup>
  </a>
);

ImportedToolbar.fragments = {
  externalPost: EXTERNAL_POST_FRAGMENT,
};

export default ImportedToolbar;
